import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Section, EmptyState } from "@/components/app/Primitives";
import { Button } from "@/components/ui/button";
import TID from "@/lib/testIds";

const kindColor = { info: "bg-slate-100 text-slate-700", approval: "bg-amber-100 text-amber-800", payment: "bg-emerald-100 text-emerald-800", onboarding: "bg-indigo-100 text-indigo-800" };

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/mark-all-read"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/mark-read`); load(); };

  return (
    <div className="space-y-6">
      <Section title="Inbox" subtitle="In-app notifications (simulates the email inbox used in production)." right={<Button variant="outline" onClick={markAll}>Mark all read</Button>} />
      {items.length === 0 ? <EmptyState title="Inbox zero" hint="No notifications yet." /> : (
        <div className="bg-white rounded-xl border overflow-hidden divide-y">
          {items.map((n) => (
            <div key={n.id} data-testid={TID.notificationRow(n.id)} className={`px-5 py-4 flex justify-between gap-4 ${n.read ? "opacity-70" : "bg-blue-50/40"}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded ${kindColor[n.kind] || kindColor.info}`}>{n.kind}</span>
                  <div className="font-semibold text-slate-800 truncate">{n.subject}</div>
                </div>
                <div className="text-sm text-slate-600 mt-1">{n.body}</div>
                <div className="text-xs text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
              </div>
              {!n.read && <button onClick={() => markOne(n.id)} className="text-xs text-[#0052FF] hover:underline shrink-0">Mark read</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
